(function () {
    var sectionSelector = '.npbp-bundle-sticky-bar';
    var itemSelector = '.npbp-bundle-sticky-bar__item';

    function findTarget(targetId) {
        if (!targetId) {
            return null;
        }

        return document.getElementById(targetId)
            || document.querySelector('[data-id="' + targetId.replace(/"/g, '\\"') + '"]')
            || document.querySelector('[data-tab-id="' + targetId.replace(/"/g, '\\"') + '"]');
    }

    function setActive(section, targetId) {
        section.querySelectorAll(itemSelector).forEach(function (item) {
            var isActive = item.getAttribute('data-target') === targetId;
            item.classList.toggle('is-active', isActive);
        });
    }

    function getStickyOffset(section) {
        return section.offsetHeight;
    }

    function updateActiveState(section) {
        var items = section.querySelectorAll(itemSelector);
        var offset = window.pageYOffset + getStickyOffset(section) + 24;
        var activeTargetId = '';

        items.forEach(function (item) {
            var targetId = item.getAttribute('data-target');
            var target = findTarget(targetId);

            if (!target) {
                return;
            }

            var targetTop = target.getBoundingClientRect().top + window.pageYOffset;

            if (targetTop <= offset) {
                activeTargetId = targetId;
            }
        });

        if (!activeTargetId && items.length > 0) {
            activeTargetId = items[0].getAttribute('data-target');
        }

        if (activeTargetId) {
            if (section.dataset.activeTargetId !== activeTargetId) {
                section.dataset.activeTargetId = activeTargetId;
                setActive(section, activeTargetId);
                
            }
        }
    }

    function bindSection(section) {
        if (section.dataset.npbpStickyBarBound === 'true') {
            updateActiveState(section);
            return;
        }

        section.dataset.npbpStickyBarBound = 'true';

        section.querySelectorAll(itemSelector).forEach(function (item) {
            item.addEventListener('click', function (event) {
                var targetId = item.getAttribute('data-target');
                var target = findTarget(targetId);

                if (!target) {
                    return;
                }

                event.preventDefault();

                window.scrollTo({
                    top: target.getBoundingClientRect().top + window.pageYOffset - getStickyOffset(section),
                    behavior: 'smooth'
                });

                section.dataset.activeTargetId = targetId;
                setActive(section, targetId);
            });
        });

        updateActiveState(section);
    }

    function init(root) {
        var scope = root || document;
        var sections = scope.matches && scope.matches(sectionSelector)
            ? [scope]
            : scope.querySelectorAll(sectionSelector);

        sections.forEach(function (section) {
            bindSection(section);
        });
    }

    document.addEventListener('DOMContentLoaded', function () {
        init(document);

        var sections = document.querySelectorAll(sectionSelector);
        sections.forEach(function(section) {
            var stickyBar = section;
            var placeholder = document.querySelector('.npbp-bundle-sticky-bar-placeholder');
            var stickyBarOffsetTop = stickyBar.offsetTop;

            window.addEventListener('scroll', function () {
                if (window.pageYOffset >= stickyBarOffsetTop) {
                    stickyBar.classList.add('is-fixed');
                    placeholder.style.height = stickyBar.offsetHeight + 'px';
                } else {
                    stickyBar.classList.remove('is-fixed');
                    placeholder.style.height = 0;
                }
                updateActiveState(section);
            });
        });

        window.addEventListener('resize', function () {
            document.querySelectorAll(sectionSelector).forEach(function (section) {
                updateActiveState(section);
            });
        });
    });

    document.addEventListener('shopify:section:load', function (event) {
        init(event.target);
    });

})();
